import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('whatsapp');

export class MessagePhone extends Api {
  constructor(http, config = {}) {
    super(http, url, 'messages/telefono', config);
  }
}